/*
 * Punkt-Navigation für die Service-Benefits-Leiste auf Mobile.
 * Dawns SliderComponent braucht Vor-/Zurück-Buttons und steigt ohne sie aus,
 * deshalb hier eine eigene, sehr kleine Variante: scroll-snap macht das Wischen,
 * das Skript synchronisiert nur die Punkte.
 */
class ServiceBenefitsSlider extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('.service-benefits__list--slider');
    this.dotsWrapper = this.querySelector('.service-benefits__dots');

    if (!this.list || !this.dotsWrapper) return;

    this.dots = Array.from(this.dotsWrapper.querySelectorAll('.service-benefits__dot'));
    if (this.dots.length < 2) return;

    this.items = Array.from(this.list.querySelectorAll('.service-benefits__item'));
    this.dotsWrapper.hidden = false;

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.list.scrollTo({ left: this.offsetForIndex(index), behavior: 'smooth' });
      });
    });

    this.list.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
    this.setActive(0);
  }

  offsetForIndex(index) {
    const item = this.items[index];
    return item ? item.offsetLeft - this.items[0].offsetLeft : 0;
  }

  onScroll() {
    if (this.scrollFrame) return;

    this.scrollFrame = requestAnimationFrame(() => {
      this.scrollFrame = null;

      // Auf Desktop scrollt die Liste nicht, dann gibt es auch nichts zu markieren.
      const step = this.items.length > 1 ? this.items[1].offsetLeft - this.items[0].offsetLeft : 0;
      if (step <= 0) return;

      this.setActive(Math.round(this.list.scrollLeft / step));
    });
  }

  setActive(index) {
    this.dots.forEach((dot, dotIndex) => {
      dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
    });
  }
}

customElements.define('service-benefits-slider', ServiceBenefitsSlider);
